import React from 'react';
import * as PropTypes from 'prop-types';

import Popup from '../../common/Popup';
import { VITALS_ACTIVITY_TYPE } from '../constants';
import { enhance } from './enhance';
import styles from './index.styl';

function AddDataModal({
  intl: { formatMessage },
  type,
  openedAddDataModal,
  close,
  component,
}) {
  const safeType =
    VITALS_ACTIVITY_TYPE.BMI === type
      ? 'portal.emptyState.bodyInfo'
      : `healthboard.${type}`;
  const handleCloseModal = () => {
    close();
  };
  const adaptTitle = formatMessage(
    {
      id: `patient.portal.emptyState.addData`,
    },
    { type: formatMessage({ id: `patient.${safeType}` }) },
  );

  return (
    <Popup
      title={adaptTitle}
      mobileFullScreen={false}
      onClose={handleCloseModal}
      opened={openedAddDataModal}
      strictClose
      overflowVisible
      withoutAdaptive
    >
      <div className={styles.root}>{component}</div>
    </Popup>
  );
}

AddDataModal.propTypes = {
  intl: PropTypes.object,
  close: PropTypes.func,
  openedAddDataModal: PropTypes.bool,
  type: PropTypes.string,
  component: PropTypes.element,
};

export default enhance(AddDataModal);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/AddDataModal/index.jsx